// Vue 2 mixin: exposes a reactive `isMobile` based on window.innerWidth.
//
// Breakpoint matches the designer's iPhone-class mockups (< 768px).
// One resize listener per component instance — fine for the agencies
// page which mounts a single top-level component. Mirror of the
// wizard's useViewport mixin (resources/js/modules/AgencyWizard/c-design/
// useViewport.js) — kept independent so the agencies module isn't
// pinned to a wizard import path.

const MOBILE_MAX_WIDTH = 768;

// IMPORTANT: the data key MUST NOT start with `_` or `$`. Vue 2 does not
// proxy underscore- or dollar-prefixed keys through `this`, so the earlier
// `this.__viewportWidth` resolved to `undefined` and `isMobile` was always
// false — which silently disabled the whole mobile layout. `cdVpW` is short
// and unprefixed. See https://v2.vuejs.org/v2/api/#data
export default {
    data() {
        return {
            cdVpW: typeof window !== "undefined" ? window.innerWidth : 1024,
        };
    },
    computed: {
        isMobile() {
            return this.cdVpW > 0 && this.cdVpW < MOBILE_MAX_WIDTH;
        },
    },
    mounted() {
        if (typeof window === "undefined") return;
        this.cdVpW = window.innerWidth;
        // The handler reference doesn't need reactivity — underscore prefix
        // is fine here (the no-proxy rule only applies to data() keys).
        this.__viewportResizeHandler = () => {
            this.cdVpW = window.innerWidth;
        };
        window.addEventListener("resize", this.__viewportResizeHandler, {
            passive: true,
        });
    },
    beforeDestroy() {
        if (this.__viewportResizeHandler) {
            window.removeEventListener("resize", this.__viewportResizeHandler);
            this.__viewportResizeHandler = null;
        }
    },
};
